import { render, staticRenderFns } from "./PurchasesTile.vue?vue&type=template&id=5cbc3d6a"
import script from "./PurchasesTile.vue?vue&type=script&lang=js"
export * from "./PurchasesTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports